import { del, get, post, put } from '@api/request';

export async function fetchPersonalDepreciationCategories(
  { appraisalService },
  authenticationToken,
  { categoryYr },
) {
  const url = `${appraisalService}/appraisal/personaldepreciationcategories/${categoryYr}`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function insertPersonalDepreciationCategory(
  { appraisalService },
  authenticationToken,
  { categoryYr, payload },
) {
  const url = `${appraisalService}/appraisal/personaldepreciationcategories/${categoryYr}`;
  const { body } = await post(authenticationToken, url, payload);

  return body;
}

export async function fetchPersonalDepreciationCategory(
  { appraisalService },
  authenticationToken,
  { categoryID },
) {
  const url = `${appraisalService}/appraisal/personaldepreciationcategory/${categoryID}`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function updatePersonalDepreciationCategory(
  { appraisalService },
  authenticationToken,
  { categoryID, payload },
) {
  const url = `${appraisalService}/appraisal/personaldepreciationcategory/${categoryID}`;
  const { body } = await put(authenticationToken, url, payload);

  return body;
}

export async function deletePersonalDepreciationCategory(
  { appraisalService },
  authenticationToken,
  { categoryID },
) {
  const url = `${appraisalService}/appraisal/personaldepreciationcategory/${categoryID}`;
  const { body } = await del(authenticationToken, url);

  return body;
}

export async function fetchDepreciationMethods(
  { appraisalService },
  authenticationToken,
  { categoryYr },
) {
  const url = `${appraisalService}/appraisal/personaldepreciationmethods/${categoryYr}?codesOnly=1`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function updatePersonalDepreciationCategoryKeywords(
  { appraisalService },
  authenticationToken,
  { categoryID, payload },
) {
  const url = `${appraisalService}/appraisal/personaldepreciationcategory/${categoryID}/keywords`;
  const { body } = await put(authenticationToken, url, payload);

  return body;
}
